
function highlightNegativeNumber(el, binding) {
  let css = '';
  let abs = false;
  if (binding.value) {
    if (binding.value.css) {
      css = binding.value.css;
    }
    if (binding.value.abs) {
      abs = binding.value.abs;
    }
  }
  setTimeout(() => {
    if ((el.innerText || '').trim()[0] == '-') {
      if (css) {
        el.className = css;
      }
      else {
        el.style.color = '#F56C6C';
      }

      if (abs) {
        el.innerText = (el.innerText || '').trim().substr(1);
      }
    }
    else {
      el.style.color = 'inherit';
    }
  }, 1);
}
export default {
  inserted: highlightNegativeNumber,
  update: highlightNegativeNumber
}
